/** Error message configuration for form field validation */
export interface IErrorMessage {
  /** Validation error type (e.g., required, maxlength, pattern) */
  type: ValidationErrorType;
  /** Translation key or error message text */
  message: string;
}

/** Validation error types matching Angular's built-in validators and custom validators */
export enum ValidationErrorType {
  Required = 'required',
  MaxLength = 'maxlength',
  MinLength = 'minlength',
  Pattern = 'pattern',
  ForbiddenName = 'forbiddenName',
  DateInvalid = 'dateInvalid',
  NoWhitespaceOnly = 'noWhitespaceOnly'
}

/** Field name constants for form inputs across the application */
export enum FieldName {
  // Address fields
  ZipCode = 'zip_code',
  City = 'city',
  Street = 'street',
  HouseNumber = 'house_number',
  Address = 'address', // combined address field (street + house number)
  Country = 'country',
  Addition = 'addition',
  CareOf = 'co',

  // Personal info fields
  Prefix = 'prefix',
  Lastname = 'name',
  FirstName = 'fname',
  Email = 'email',

  // Phone fields
  Telephone1 = 'telephone1',
  Telephone2 = 'telephone2',
  TelephoneMobile = 'telephone_mobile',

  // Date fields
  BirthDate = 'bday_ymd',

  // Group order fields
  GroupName = 'group_name',
  UserName = 'user_name'
}


